module.exports = __webpack_public_path__ + "html/rule-form.template.html";